// extracted by mini-css-extract-plugin
var _1 = "src-components-HomePage-_TextDialog__dialogCloseButton--HJCZs5LDMNOv4oxFCsNq";
var _2 = "src-components-HomePage-_TextDialog__dialogCloseButtonWrapper--YMnKX8FUzefQoZXN2O8Z";
var _3 = "src-components-HomePage-_TextDialog__dialogText--_Ac89aYKFFwCXZr44v97";
var _4 = "src-components-HomePage-_TextDialog__textDialog--TE_ZzUwqII2g1SGjXgsl";
export { _1 as "dialogCloseButton", _2 as "dialogCloseButtonWrapper", _3 as "dialogText", _4 as "textDialog" }
